/* eslint-disable @eslint-react/dom/no-dangerously-set-innerhtml */
import { getComponentFromName } from '@folklore/utils';
import { ForwardedRef, HTMLAttributes } from 'react';
import tinycolor from 'tinycolor2';

import useFormatImageUrl from '../../hooks/useFormatImageUrl';
import { getImageUrl } from '../../lib/getImageSize';

import * as ThemeComponents from './index';

interface DocumentThemeProps extends HTMLAttributes<HTMLDivElement> {
    id: string;
    containerClassName: string;
    name?: string | null;
    primaryColor?: string | null;
    backgroundColor?: string | null;
    textColor?: string | null;
    backgroundImage?: Image | null;
    children: React.ReactNode;
}

function DocumentTheme({
    id,
    containerClassName,
    name = null,
    primaryColor = null,
    backgroundColor = null,
    textColor = null,
    backgroundImage = null,
    children,
    ref: containerRef = null,
    ...props
}: DocumentThemeProps & { ref?: ForwardedRef<HTMLDivElement> | null }) {
    const formatImageUrl = useFormatImageUrl();
    const backgroundImageUrl = formatImageUrl(getImageUrl(backgroundImage, 'large'));
    const ThemeWrapper = getComponentFromName(ThemeComponents, name, null);
    const backgroundColorIsDark = backgroundColor !== null && tinycolor(backgroundColor).isDark();
    return (
        <>
            <style
                type="text/css"
                dangerouslySetInnerHTML={{
                    __html: `
                #${id}.${containerClassName} {
                    ${primaryColor !== null ? `--document-primary-color: ${primaryColor};` : ''}
                    ${textColor !== null ? `--document-text-color: ${textColor};` : ''}
                    ${backgroundColor !== null ? `--document-background-color: ${backgroundColor};` : ''}
                    ${backgroundColor !== null && primaryColor === null ? `--document-primary-color: ${backgroundColorIsDark ? '#fff' : '#000'};` : ''}
                    ${backgroundColor !== null && textColor === null ? `--document-text-color: ${backgroundColorIsDark ? '#fff' : '#000'};` : ''}
                    ${backgroundColor !== null && backgroundImageUrl !== null ? `--document-background: ${backgroundColor} url("${backgroundImageUrl}") top center repeat;` : ''}
                    ${backgroundColor !== null && backgroundImageUrl === null ? `--document-background: ${backgroundColor};` : ''}
                    ${backgroundImageUrl !== null && backgroundColor === null ? `--document-background: url("${backgroundImageUrl}") top center repeat;` : ''}
                }
            `,
                }}
            />
            {ThemeWrapper !== null ? (
                <ThemeWrapper id={id} {...props} ref={containerRef}>
                    {children}
                </ThemeWrapper>
            ) : (
                <div id={id} {...props} ref={containerRef}>
                    {children}
                </div>
            )}
        </>
    );
}

export default DocumentTheme;
